module.exports = __webpack_public_path__ + "files/caaf9e0984beeeb1f73d4bc68f23260c.png";